exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-route {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #f8f9fa; }\n  .auth-route .auth-content {\n    background-color: white;\n    width: 350px;\n    padding: 50px; }\n  .auth-route .auth-extra-container a {\n    display: block;\n    margin: 10px 0; }\n", ""]);

// exports
